import { makeStyles } from '@material-ui/core/styles'

import { getFont } from '../../../../../localization'

export default makeStyles((theme) => ({
  weekDayDefaultStyle: {
    width: 48,
    lineHeight: '48px',
    textAlign: 'center',
    fontSize: 14,
    color: '#a7a7a7',
    fontFamily: getFont(),
    [theme.breakpoints.down('sm')]: {
      width: '14%'
    }
  },
  weekDaysNamesContainer: {
    width: '92%',
    margin: 'auto'
  }
}))
